var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon_visa",
    xmlns: "http://www.w3.org/2000/svg",
    width: 45.854,
    height: 13.902,
    viewBox: "0 0 45.854 13.902",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M184.8,193.5l2.329-13.1h3.639l-2.256,13.1Z",
    transform: "translate(-167.987 -179.963)",
    fill: "#3c58bf"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M184.8,193.5l2.984-13.1h2.984l-2.256,13.1Z",
    transform: "translate(-167.987 -179.963)",
    fill: "#293688"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M259.136,176.182a9.232,9.232,0,0,0-3.348-.582c-3.639,0-6.259,1.82-6.259,4.44,0,1.965,1.82,2.984,3.275,3.639s1.892,1.092,1.892,1.674c0,.873-1.165,1.31-2.184,1.31a7.911,7.911,0,0,1-3.494-.728l-.509-.218L248,188.7a11.8,11.8,0,0,0,4.149.728c3.858,0,6.4-1.82,6.4-4.585,0-1.528-.946-2.693-3.13-3.639-1.31-.655-2.111-1.019-2.111-1.674,0-.582.655-1.165,2.111-1.165a6.676,6.676,0,0,1,2.766.509l.364.146.582-2.839Z",
    transform: "translate(-225.437 -175.6)",
    fill: "#3c58bf"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M259.136,176.182a9.232,9.232,0,0,0-3.348-.582c-3.639,0-5.6,1.82-5.6,4.44a3.8,3.8,0,0,0,2.62,3.639c1.456.655,1.892,1.092,1.892,1.674,0,.873-1.165,1.31-2.184,1.31a7.911,7.911,0,0,1-3.494-.728l-.509-.218L248,188.7a11.8,11.8,0,0,0,4.149.728c3.858,0,6.4-1.82,6.4-4.585,0-1.528-.946-2.693-3.13-3.639-1.31-.655-2.111-1.019-2.111-1.674,0-.582.655-1.165,2.111-1.165a6.676,6.676,0,0,1,2.766.509l.364.146.582-2.839Z",
    transform: "translate(-225.437 -175.6)",
    fill: "#293688"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M365.751,180.4c-.873,0-1.528.073-1.892.946L358.4,193.5h3.93l.728-2.184h4.658l.437,2.184h3.494l-3.057-13.1Zm-1.674,8.734c.218-.655,1.456-3.858,1.456-3.858s.291-.8.509-1.31l.218,1.237s.728,3.275.873,4h-3.057Z",
    transform: "translate(-325.793 -179.963)",
    fill: "#3c58bf"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M366.625,180.4c-.873,0-1.528.073-1.892.946L358.4,193.5h3.93l.728-2.184h4.658l.437,2.184h3.494l-3.057-13.1Zm-2.547,8.734c.291-.728,1.456-3.858,1.456-3.858s.291-.8.509-1.31l.218,1.237s.728,3.275.873,4h-3.057Z",
    transform: "translate(-325.793 -179.963)",
    fill: "#293688"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M56.659,190.3l-.364-1.892a10.551,10.551,0,0,0-5.095-5.75L54.475,194.3h3.93l5.9-13.1h-3.93Z",
    transform: "translate(-46.542 -180.691)",
    fill: "#3c58bf"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M56.659,190.3l-.364-1.892a10.551,10.551,0,0,0-5.095-5.75L54.475,194.3h3.93l5.9-13.1H61.1Z",
    transform: "translate(-46.542 -180.691)",
    fill: "#293688"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M0,180.4l.655.146c4.658,1.092,7.861,3.858,9.1,7.133l-1.31-6.187c-.218-.873-.873-1.092-1.674-1.092Z",
    transform: "translate(0 -179.963)",
    fill: "#ffbc00"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M0,180.4H0c4.658,1.092,8.516,3.93,9.753,7.206l-1.237-5.168a1.777,1.777,0,0,0-1.747-1.383Z",
    transform: "translate(0 -179.963)",
    fill: "#f7981d"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M0,180.4H0c4.658,1.092,8.516,3.93,9.753,7.206l-.873-2.839a2.567,2.567,0,0,0-1.528-2.111Z",
    transform: "translate(0 -179.963)",
    fill: "#ed7c00"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_117",
    "data-name": "Group 117",
    transform: "translate(4.731 1.892)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M61.025,203.678,58.551,201.2l-1.165,2.766-.291-1.82A10.551,10.551,0,0,0,52,196.4l3.275,11.645h3.93Z",
    transform: "translate(-52 -196.4)",
    fill: "#051244"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M188.512,292.4l-3.13-3.2-.582,3.2Z",
    transform: "translate(-172.718 -280.757)",
    fill: "#051244"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M254.332,274.8h0c.291.291.437.51.364.8,0,.873-1.165,1.31-2.184,1.31a7.911,7.911,0,0,1-3.494-.728l-.509-.218L248,278.949a11.8,11.8,0,0,0,4.149.728,7.206,7.206,0,0,0,5.313-1.82Z",
    transform: "translate(-230.168 -267.667)",
    fill: "#051244"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M364,229.135h3.421l.728-2.184h4.658l.437,2.184h3.494l-1.237-5.313-4.367-4.221.218,1.165s.728,3.275.873,4h-3.057c.291-.728,1.456-3.858,1.456-3.858s.291-.8.51-1.31",
    transform: "translate(-335.614 -217.489)",
    fill: "#051244"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.9f324558f8b0f67f7dd3dd3bb34317f1.svg";
export { ForwardRef as ReactComponent };